import React from 'react';
import moment from 'moment';
import {isNil} from 'lodash';
import PropTypes from 'prop-types';
import {Popup} from 'semantic-ui-react';

import {DATETIME_SECONDS_FORMAT, TIME_FORMAT} from '@utils/date';

const formatDateTime = (datetime, format = TIME_FORMAT) => moment(datetime).format(format);

const renderJobTimeTooltip = (displayText, tooltipText) => (
    <Popup
        trigger={<span>{displayText}</span>}
        content={tooltipText}
    />
);

const hasMargin = (margin) => !isNil(margin);

export const ArgosJobStartTime = ({row}) => {
    if (row.start_datetime) {
        const text = hasMargin(row.start_margin)
            ? `${formatDateTime(row.start_datetime)} (-${row.start_margin} min)`
            : formatDateTime(row.start_datetime);
        let tooltip = formatDateTime(row.start_datetime, DATETIME_SECONDS_FORMAT);

        if (hasMargin(row.start_margin)) {
            tooltip += ` (${row.start_margin} minutes before the event start time)`;
        }

        return renderJobTimeTooltip(text, tooltip);
    }

    if (!hasMargin(row.start_margin) || !row.event_start_datetime) {
        return 'Manual';
    }

    const start = moment(row.event_start_datetime).subtract(row.start_margin, 'minutes');

    return renderJobTimeTooltip(
        `${start.format(TIME_FORMAT)} (-${row.start_margin} min)`,
        `${start.format(DATETIME_SECONDS_FORMAT)} (${row.start_margin} minutes before the event start time)`
    );
};

ArgosJobStartTime.propTypes = {
    row: PropTypes.object.isRequired,
};

export const ArgosJobEndTime = ({row}) => {
    if (row.end_datetime) {
        const text = hasMargin(row.end_margin)
            ? `${formatDateTime(row.end_datetime)} (+${row.end_margin} min)`
            : formatDateTime(row.end_datetime);
        let tooltip = formatDateTime(row.end_datetime, DATETIME_SECONDS_FORMAT);

        if (hasMargin(row.end_margin)) {
            tooltip += row.event_end_datetime
                ? ` (${row.end_margin} minutes after the event end time)`
                : ` (${row.end_margin} minutes after the end of the match)`;
        }

        return renderJobTimeTooltip(text, tooltip);
    }

    if (!hasMargin(row.end_margin)) {
        return 'Manual';
    }

    if (!row.event_end_datetime) {
        return renderJobTimeTooltip(
            `+${row.end_margin} min`,
            `${row.end_margin} minutes after the end of the match`
        );
    }

    const end = moment(row.event_end_datetime).add(row.end_margin, 'minutes');

    return renderJobTimeTooltip(
        `${end.format(TIME_FORMAT)} (+${row.end_margin} min)`,
        `${end.format(DATETIME_SECONDS_FORMAT)} (${row.end_margin} minutes after the event end time)`
    );
};

ArgosJobEndTime.propTypes = {
    row: PropTypes.object.isRequired,
};
